import { NgModule, ModuleWithProviders, Type } from '@angular/core';
import { EffectSources } from './effect_sources';
import { Actions } from './actions';
import { ROOT_EFFECTS, FEATURE_EFFECTS, CONSOLE } from './tokens';
import { EffectsFeatureModule } from './effects_feature_module';
import { EffectsRootModule } from './effects_root_module';
import { EffectsRunner } from './effects_runner';
import { ErrorReporter } from './error_reporter';
export class EffectsModule {
/**
 * @param {?} featureEffects
 * @return {?}
 */
static forFeature(featureEffects: Type<any>[]): ModuleWithProviders {
    return {
      ngModule: EffectsFeatureModule,
      providers: [
        featureEffects,
        {
          provide: FEATURE_EFFECTS,
          multi: true,
          deps: featureEffects,
          useFactory: createSourceInstances,
        },
      ],
    };
  }
/**
 * @param {?} rootEffects
 * @return {?}
 */
static forRoot(rootEffects: Type<any>[]): ModuleWithProviders {
    return {
      ngModule: EffectsRootModule,
      providers: [
        EffectsRunner,
        EffectSources,
        ErrorReporter,
        Actions,
        rootEffects,
        {
          provide: ROOT_EFFECTS,
          deps: rootEffects,
          useFactory: createSourceInstances,
        },
        {
          provide: CONSOLE,
          useFactory: getConsole,
        },
      ],
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function EffectsModule_tsickle_Closure_declarations() {
/** @type {?} */
EffectsModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
EffectsModule.ctorParameters;
}

/**
 * @param {...?} instances
 * @return {?}
 */
export function createSourceInstances(...instances: any[]) {
  return instances;
}
/**
 * @return {?}
 */
export function getConsole() {
  return console;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}



// WEBPACK FOOTER //
// ../../../modules/effects/src/effects_module.ts